/* Skapad av Claude Code — "Lägg till" på SVD-produktkortet (snippets/svd-product-card.liquid).

   Flöde vid klick på [data-svd-qa]:
   1. Hämta produktsidans huvudsektion för produktens EGEN mall via Section
      Rendering API (?section_id=template--<id>__main-product). Mall-id:t syns inte
      i Liquid, så det läses en gång per mall+marknad ur början av produktsidan
      (strömmad läsning, avbryts direkt när id:t hittats) och cachas i localStorage.
   2. Finns en SVD-väljare ([data-svd-picker]) i sektionen → den glider upp i
      bladet, dess egen CSS/JS laddas och den monteras (event svd:picker:mount).
      Köpet görs av väljarens EGEN köpknapp → exakt samma payload som på PDP:n
      (gåvor, stämplar, rabattkoder, prenumeration). Väljaren signalerar lyckat
      köp med svd:picker:added.
   3. Ingen väljare + en variant → direkt i varukorgen (/cart/add.js).
   4. Ingen väljare + flera varianter → enkel radiolista byggd ur /products/<h>.js.
   5. Allt som går fel → vanlig länk till produktsidan (kunden tappas aldrig).

   KONTRAKT för en ny väljartyp (så att den hänger med in i bladet automatiskt):
   - Rotelementet har data-svd-picker, data-svd-picker-js="<asset_url>" och
     (om den har egen css) data-svd-picker-css="<asset_url>".
   - JS:en lyssnar på document 'svd:picker:mount' och monterar rötter i e.detail.root.
   - Efter lyckat /cart/add: rot.dispatchEvent(new CustomEvent('svd:picker:added', {bubbles:true})).
   Saknas kontraktet visar bladet "Välj på produktsidan →".

   MALLENS FÄRGER (Marcus 2026-10): bladet får produktmallens body-klasser
   (template-product + template-product-<mall>) och laddar mallens palett-CSS
   (svd-pdp-intro-*.css som länkas inne i main-product). Mall-scopade färger,
   t.ex. Hud och Päls orange, följer då med in i bladet utan kod per produkt.
   Ny produktpalett = lägg den i en svd-pdp-intro-*.css, scopad med .template-product-<mall>. */
(function () {
  'use strict';
  if (window.SvdQuickAdd) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var THEME = (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '0';
  var LS_KEY = 'svd-qa-mallar:' + THEME + ':' + ROOT;
  var PICKER = '[data-svd-picker]';
  var CTA_SEL = '[data-svd-picker-cta],[data-bundle-cta],[data-sf-cta],[data-gp-atc],.svd-vs__atc';
  var PALETT_CSS = /\/svd-pdp-intro[^/?]*\.css/;
  var BODY_KLASS = 'svd-qa__body shopify-section';
  var TXT = { add: 'Lägg till', close: 'Stäng', choose_on_pdp: 'Välj på produktsidan →', add_to_cart: 'Lägg i varukorgen',
    out_of_stock: 'Slut i lager', choose: 'Välj', error: 'Något gick fel. Försök igen.', sold_out: 'Slutsåld' };
  try {
    var tEl = document.getElementById('svd-qa-t');
    var tJson = tEl && JSON.parse(tEl.textContent);
    if (tJson) for (var tk in tJson) { if (tJson[tk]) TXT[tk] = tJson[tk]; }
  } catch (e) { /* svenska reservtexter */ }
  var prefetched = {};       // url -> Promise<resultat>
  var sectionIds = readIds(); // mall -> sektions-id
  var idPromises = {};

  /* Robusthet: inget löfte får hänga – efter ms ges upp och kunden får länken till produktsidan. */
  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }
  function readIds() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function saveIds() {
    try { localStorage.setItem(LS_KEY, JSON.stringify(sectionIds)); } catch (e) { /* privat läge */ }
  }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
    var lang = document.documentElement.lang || 'sv';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur,
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100);
    } catch (e) { return Math.round(cents / 100) + ' kr'; }
  }
  function productPath(url) {
    // Produktens URL från kortet är redan marknadsprefixad (p.url). Ta bort query.
    return String(url || '').split('?')[0];
  }

  /* ---------- 1. Sektions-id för produktens mall ---------- */
  var ID_RE = /id="shopify-section-(template--\d+__main-product)"/;
  function sectionIdFor(btn) {
    var mall = btn.getAttribute('data-mall') || '_standard';
    if (sectionIds[mall]) return Promise.resolve(sectionIds[mall]);
    if (idPromises[mall]) return idPromises[mall];
    var url = productPath(btn.getAttribute('data-url'));
    var ctrl = window.AbortController ? new AbortController() : null;
    idPromises[mall] = fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        if (!res.ok) { var err = new Error('pdp ' + res.status); err.status = res.status; throw err; }
        if (!res.body || !res.body.getReader || !window.TextDecoder) {
          return res.text().then(function (t) { var m = t.match(ID_RE); return m ? m[1] : null; });
        }
        var reader = res.body.getReader();
        var dec = new TextDecoder();
        var buf = '';
        function pump() {
          return reader.read().then(function (r) {
            if (r.done) { var m0 = buf.match(ID_RE); return m0 ? m0[1] : null; }
            buf += dec.decode(r.value, { stream: true });
            var m = buf.match(ID_RE);
            if (m) { try { ctrl && ctrl.abort(); } catch (e) {} return m[1]; }
            if (buf.length > 4000000) return null;
            return pump();
          });
        }
        return pump();
      })
      .then(function (id) {
        if (id) { sectionIds[mall] = id; saveIds(); }
        delete idPromises[mall];
        return id;
      }, function (err) { delete idPromises[mall]; throw err; });
    return idPromises[mall];
  }

  /* ---------- 2. Hämta väljaren ---------- */
  function load(btn, opts) {
    var url = productPath(btn.getAttribute('data-url'));
    if (prefetched[url]) return prefetched[url];
    var mall = btn.getAttribute('data-mall') || '_standard';
    var p = sectionIdFor(btn).then(function (sid) {
      if (!sid) return { picker: null };
      var hamta = function (forsok) {
        return fetch(url + '?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' }).then(function (res) {
          if (res.status === 404) { delete sectionIds[mall]; saveIds(); throw new Error('stale section id'); }
          // Butikens skydd (429/503) vid många anrop: ett nytt försök efter en kort paus
          if ((res.status === 429 || res.status >= 500) && forsok < 1 && !(opts && opts.bakgrund)) {
            return new Promise(function (r) { setTimeout(r, 900); }).then(function () { return hamta(forsok + 1); });
          }
          if (!res.ok) { var err = new Error('sr ' + res.status); err.status = res.status; throw err; }
          return res.text();
        });
      };
      return hamta(0)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var picker = doc.querySelector(PICKER);
          sectionIds[mall + '|picker'] = picker ? 1 : 0; saveIds();
          var extras = picker ? Array.prototype.slice.call(doc.querySelectorAll('[data-svd-lpo]')) : [];
          var palett = [];
          Array.prototype.forEach.call(doc.querySelectorAll('link[rel="stylesheet"][href]'), function (l) {
            var href = l.getAttribute('href');
            if (PALETT_CSS.test(href) && palett.indexOf(href) === -1) palett.push(href);
          });
          return { picker: picker, extras: extras, palett: palett };
        });
    });
    prefetched[url] = p;
    p.catch(function () { delete prefetched[url]; });
    return p;
  }

  var loadedAssets = {};
  function assetLoaded(src) {
    var path = src.split('?')[0];
    if (loadedAssets[path]) return true;
    var nodes = document.querySelectorAll('script[src],link[rel="stylesheet"]');
    for (var i = 0; i < nodes.length; i++) {
      var s = nodes[i].getAttribute('src') || nodes[i].getAttribute('href') || '';
      if (s.split('?')[0] === path) return true;
    }
    return false;
  }
  function loadCss(href) {
    if (!href || assetLoaded(href)) return Promise.resolve();
    loadedAssets[href.split('?')[0]] = true;
    return new Promise(function (resolve) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      l.onload = l.onerror = function () { resolve(); };
      document.head.appendChild(l);
    });
  }
  function loadJs(src) {
    if (!src || assetLoaded(src)) return Promise.resolve();
    loadedAssets[src.split('?')[0]] = true;
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('js ' + src)); };
      document.head.appendChild(s);
    });
  }

  /* ---------- Bladet ---------- */
  var sheet, overlay, body, headImg, headTitle, headRating, closeBtn, wrap, lastBtn, observer;
  function buildSheet() {
    if (wrap) return;
    wrap = document.createElement('div');
    wrap.className = 'svd-qa';
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="svd-qa__overlay" data-svd-qa-close></div>' +
      '<div class="svd-qa__sheet" role="dialog" aria-modal="true" aria-labelledby="svd-qa-title">' +
        '<div class="svd-qa__grab" aria-hidden="true"></div>' +
        '<button type="button" class="svd-qa__close" data-svd-qa-close aria-label="' + TXT.close + '">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<div class="svd-qa__head">' +
          '<div class="svd-qa__thumb"><img alt="" width="64" height="64"></div>' +
          '<div class="svd-qa__head-txt"><span class="svd-qa__title" id="svd-qa-title"></span>' +
          '<div class="svd-qa__rating" hidden><span class="svd-qa__stars" aria-hidden="true">★★★★★</span><span class="svd-qa__rating-num"></span></div></div>' +
        '</div>' +
        '<div class="' + BODY_KLASS + '"></div>' +
      '</div>';
    document.body.appendChild(wrap);
    sheet = wrap.querySelector('.svd-qa__sheet');
    overlay = wrap.querySelector('.svd-qa__overlay');
    body = wrap.querySelector('.svd-qa__body');
    headImg = wrap.querySelector('.svd-qa__thumb img');
    headTitle = wrap.querySelector('.svd-qa__title');
    headRating = wrap.querySelector('.svd-qa__rating');
    closeBtn = wrap.querySelector('.svd-qa__close');
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-svd-qa-close]')) close();
    });
    wrap.addEventListener('keydown', onKey);
    /* Svep ned för att stänga (mobil), samma känsla som "Tillagd i varukorgen"-bladet:
       bladet följer fingret när innehållet är skrollat till toppen (eller greppet/huvudet
       dras); släpp efter > 90 px eller en snabb flick nedåt = stäng, annars tillbaka. */
    var drag = null;
    sheet.addEventListener('touchstart', function (e) {
      if (window.matchMedia('(min-width: 750px)').matches || !e.touches || e.touches.length !== 1) return;
      var fromHead = !!e.target.closest('.svd-qa__grab, .svd-qa__head');
      if (!fromHead && sheet.scrollTop > 0) return;
      drag = { y: e.touches[0].clientY, t: Date.now(), dy: 0, head: fromHead, on: false };
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var dy = e.touches[0].clientY - drag.y;
      if (!drag.on) {
        if (dy < 6) { if (dy < -6) drag = null; return; } // uppåt = vanlig skroll
        if (!drag.head && sheet.scrollTop > 0) { drag = null; return; }
        drag.on = true;
        sheet.style.transition = 'none';
        overlay.style.transition = 'none';
      }
      drag.dy = Math.max(0, dy);
      if (e.cancelable) e.preventDefault();
      sheet.style.transform = 'translateY(' + drag.dy + 'px)';
      overlay.style.opacity = String(Math.max(0, 1 - drag.dy / (sheet.offsetHeight || 600)));
    }, { passive: false });
    function slappDrag() {
      if (!drag) return;
      var d = drag; drag = null;
      if (!d.on) return;
      sheet.style.transition = ''; overlay.style.transition = '';
      var fart = d.dy / Math.max(1, Date.now() - d.t);
      if (d.dy > 90 || (fart > 0.6 && d.dy > 24)) {
        sheet.style.transform = ''; overlay.style.opacity = '';
        close();
      } else {
        sheet.style.transform = ''; overlay.style.opacity = '';
      }
    }
    sheet.addEventListener('touchend', slappDrag, { passive: true });
    sheet.addEventListener('touchcancel', slappDrag, { passive: true });
    body.addEventListener('svd:picker:added', function () { onAdded(); });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      sheet.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function fillHead(btn) {
    headImg.src = btn.getAttribute('data-img') || '';
    headTitle.textContent = btn.getAttribute('data-title') || '';
    var r = btn.getAttribute('data-rating');
    if (r) {
      headRating.hidden = false;
      headRating.querySelector('.svd-qa__stars').style.setProperty('--svd-qa-pct', (parseFloat(r) * 20) + '%');
      headRating.querySelector('.svd-qa__rating-num').textContent = r;
    } else {
      headRating.hidden = true;
    }
  }

  function open(btn) {
    buildSheet();
    lastBtn = btn;
    fillHead(btn);
    body.className = BODY_KLASS;
    body.innerHTML = '<div class="svd-qa__skeleton" aria-hidden="true"><span></span><span></span><span></span></div>';
    wrap.hidden = false;
    document.documentElement.classList.add('svd-qa-open');
    // tvinga reflow så transitionen spelas
    void sheet.offsetHeight;
    wrap.classList.add('is-open');
    closeBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!wrap || wrap.hidden) return;
    wrap.classList.remove('is-open');
    document.documentElement.classList.remove('svd-qa-open');
    stopWatch();
    var done = function () {
      wrap.hidden = true;
      body.innerHTML = '';
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 320);
    if (lastBtn) { try { lastBtn.focus({ preventScroll: true }); } catch (e) {} }
  }

  function isOpenFor(btn) { return wrap && !wrap.hidden && lastBtn === btn; }
  function fallbackLink(btn) {
    body.innerHTML = '';
    var a = document.createElement('a');
    a.className = 'svd-qa__fallback';
    a.href = btn.getAttribute('data-url');
    a.textContent = TXT.choose_on_pdp;
    body.appendChild(a);
  }

  /* Robust reserv: om en väljare saknar svd:picker:added — se /cart/add på resursnivå. */
  function watchAdds() {
    stopWatch();
    if (!window.PerformanceObserver) return;
    try {
      observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (en.name && en.name.indexOf('/cart/add') !== -1) {
            if (en.responseStatus && en.responseStatus >= 400) return;
            setTimeout(onAdded, 350);
          }
        });
      });
      observer.observe({ type: 'resource', buffered: false });
    } catch (e) { observer = null; }
  }
  function stopWatch() { if (observer) { try { observer.disconnect(); } catch (e) {} observer = null; } }

  var addedHandled = 0;
  function onAdded() {
    if (Date.now() - addedHandled < 1500) return;
    addedHandled = Date.now();
    var btn = lastBtn;
    close();
    if (btn) markAdded(btn);
    refreshBubble();
  }

  /* Produktmallens body-klasser, som temat skriver dem i layout/theme.liquid:
     template-product + template-product-<mall> (mallens suffix som handle). */
  function mallKlasser(btn) {
    var mall = String(btn.getAttribute('data-mall') || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return 'template-product' + (mall ? ' template-product-' + mall : '');
  }

  function mountPicker(res, btn) {
    var picker = document.importNode(res.picker, true);
    body.innerHTML = '';
    body.className = BODY_KLASS + ' ' + mallKlasser(btn);
    res.extras.forEach(function (x) { if (!picker.contains(x)) body.appendChild(document.importNode(x, true)); });
    body.appendChild(picker);
    var css = picker.getAttribute('data-svd-picker-css');
    var js = picker.getAttribute('data-svd-picker-js');
    var palett = (res.palett || []).map(loadCss);
    return Promise.all([loadCss(css), loadJs(js)].concat(palett)).then(function () {
      document.dispatchEvent(new CustomEvent('svd:picker:mount', { detail: { root: body } }));
      picker.classList.add('svd-qa-mounted');
      // Färgen vald på kortet (annars kortets förvalda variant) läggs i med 1 st
      // i väljare som har "Lägg till" per variant (slow feeder-väljaren).
      var pre = btn.getAttribute('data-pre-variant') || btn.getAttribute('data-variant-id');
      var hit = pre && picker.querySelector('[data-variant-id="' + pre + '"] [data-sf-add]');
      if (hit && !hit.disabled) { try { hit.click(); } catch (e) {} }
      var cta = picker.querySelector(CTA_SEL);
      if (cta) cta.classList.add('svd-qa-cta');
      watchAdds();
    });
  }

  /* ---------- 4. Enkel variantlista ---------- */
  function simpleList(btn) {
    var url = productPath(btn.getAttribute('data-url'));
    return fetch(url + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (prod) {
      var pre = btn.getAttribute('data-pre-variant');
      var sel = null;
      prod.variants.forEach(function (v) { if (!sel && v.available && (!pre || String(v.id) === pre)) sel = v; });
      if (!sel) prod.variants.forEach(function (v) { if (!sel && v.available) sel = v; });
      var optName = (prod.options && prod.options[0] && (prod.options[0].name || prod.options[0])) || 'alternativ';
      var h = '<div class="svd-qa-list">' +
        '<div class="svd-qa-list__label"><span></span><span class="svd-qa-list__label-txt"></span><span></span></div>' +
        '<div class="svd-qa-list__rows" role="radiogroup"></div>' +
        '<div class="svd-qa-list__cta svd-qa-cta"><button type="button" class="svd-qa-list__btn"><span class="svd-qa-list__btn-lbl">' + TXT.add_to_cart + '</span><span class="svd-qa-list__dot">·</span><span class="svd-qa-list__btn-price"></span></button>' +
        '<p class="svd-qa-list__err" role="alert" hidden></p></div>' +
      '</div>';
      body.innerHTML = h;
      body.querySelector('.svd-qa-list__label-txt').textContent = TXT.choose + ' ' + String(optName).toLowerCase();
      var rows = body.querySelector('.svd-qa-list__rows');
      var priceEl = body.querySelector('.svd-qa-list__btn-price');
      var addBtn = body.querySelector('.svd-qa-list__btn');
      prod.variants.forEach(function (v) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'svd-qa-list__row';
        row.setAttribute('role', 'radio');
        row.setAttribute('aria-checked', sel && v.id === sel.id ? 'true' : 'false');
        if (!v.available) { row.disabled = true; row.classList.add('is-slut'); }
        row.innerHTML = '<span class="svd-qa-list__radio"></span><span class="svd-qa-list__name"></span>' +
          '<span class="svd-qa-list__prices"><span class="svd-qa-list__now"></span>' +
          (v.compare_at_price > v.price ? '<s class="svd-qa-list__was"></s>' : '') + '</span>';
        row.querySelector('.svd-qa-list__name').textContent = v.title;
        if (!v.available) {
          var sub = document.createElement('span'); sub.className = 'svd-qa-list__sub'; sub.textContent = TXT.out_of_stock;
          row.querySelector('.svd-qa-list__name').appendChild(sub);
        }
        row.querySelector('.svd-qa-list__now').textContent = money(v.price);
        if (v.compare_at_price > v.price) row.querySelector('.svd-qa-list__was').textContent = money(v.compare_at_price);
        row.addEventListener('click', function () {
          sel = v;
          Array.prototype.forEach.call(rows.children, function (r) { r.setAttribute('aria-checked', 'false'); });
          row.setAttribute('aria-checked', 'true');
          priceEl.textContent = money(v.price);
        });
        rows.appendChild(row);
      });
      priceEl.textContent = sel ? money(sel.price) : '';
      addBtn.disabled = !sel;
      addBtn.addEventListener('click', function () {
        if (!sel) return;
        addBtn.classList.add('is-loading'); addBtn.disabled = true;
        cartAdd(sel.id).then(function () {
          onAdded();
        }, function (msg) {
          var err = body.querySelector('.svd-qa-list__err');
          err.textContent = msg; err.hidden = false;
        }).then(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = false; });
      });
    });
  }

  /* ---------- 3. Direkt i varukorgen ---------- */
  /* quiet = SvdNotis-bladet visas inte (sections/svd-notis läser flaggan). Används av
     kortens antalsläge: kunden ska kunna trycka + direkt utan att ett blad täcker kortet. */
  function cartAdd(variantId, quiet) {
    if (quiet) window.__svdQuietAddUntil = Date.now() + 4000;
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-bubble', sections_url: location.pathname })
    }).then(function (res) {
      if (quiet) window.__svdQuietAddUntil = Date.now() + 1500;
      return res.json().then(function (data) {
        if (!res.ok || data.status) return Promise.reject(data.description || data.message || TXT.error);
        renderBubble(data.sections && data.sections['cart-bubble']);
        try {
          if (typeof window.dispatchCustomEvent === 'function') {
            window.dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
          }
        } catch (e) {}
        return data;
      });
    });
  }

  function renderBubble(html) {
    var host = document.querySelector('#cart-drawer-toggle .thb-item-count');
    if (!host || !html) return false;
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector('.thb-item-count');
    if (el) host.innerHTML = el.innerHTML;
    bump(host);
    return true;
  }
  function refreshBubble() {
    fetch(ROOT + '?sections=cart-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { renderBubble(d && d['cart-bubble']); })
      .catch(function () {});
  }
  function bump(el) {
    el.classList.remove('svd-qa-bump');
    void el.offsetWidth;
    el.classList.add('svd-qa-bump');
  }

  function markAdded(btn) {
    btn.classList.add('is-added');
    btn.setAttribute('aria-live', 'polite');
    clearTimeout(btn._svdT);
    btn._svdT = setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
  }

  /* ---------- Antalsläge: − 1 + på kortet ---------- */
  function plainLine(item) {
    var pr = item && item.properties;
    if (!pr) return true;
    for (var k in pr) { if (Object.prototype.hasOwnProperty.call(pr, k) && pr[k] !== '' && pr[k] != null) return false; }
    return true;
  }
  function findLine(items, variantId) {
    for (var i = 0; i < (items || []).length; i++) {
      if (String(items[i].variant_id) === String(variantId) && plainLine(items[i])) return items[i];
    }
    return null;
  }
  function setQty(card, qty, key) {
    var btn = card.querySelector('[data-svd-qa]');
    var box = card.querySelector('[data-svd-pc-qty]');
    if (!box || !btn) return;
    box._key = key || null;
    box._qty = qty;
    if (qty > 0) {
      box.querySelector('.svd-pc__qty-num').textContent = qty;
      btn.hidden = true;
      box.hidden = false;
    } else {
      box.hidden = true;
      btn.hidden = false;
      btn.classList.remove('is-added');
    }
  }
  function bumpQty(box) {
    box.classList.remove('is-bump'); void box.offsetWidth; box.classList.add('is-bump');
  }
  function changeLine(key, qty) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-bubble', sections_url: location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) return Promise.reject(data.description || data.message || TXT.error);
        renderBubble(data.sections && data.sections['cart-bubble']);
        return data;
      });
    });
  }
  function onQty(box, delta) {
    if (box.classList.contains('is-busy')) return;
    var card = box.closest('[data-svd-pc]');
    var vid = box.getAttribute('data-variant-id');
    box.classList.add('is-busy');
    var job;
    if (delta > 0) {
      job = cartAdd(vid, true).then(function (data) {
        var line = findLine(data.items || [data], vid);
        setQty(card, line ? line.quantity : (box._qty || 0) + 1, line && line.key);
        bumpQty(box);
      });
    } else {
      var next = Math.max(0, (box._qty || 1) - 1);
      var withKey = box._key ? Promise.resolve(box._key) : fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (c) { var l = findLine(c.items, vid); return l && l.key; });
      job = withKey.then(function (key) {
        if (!key) { setQty(card, 0); return; }
        return changeLine(key, next).then(function (cart) {
          var line = findLine(cart.items, vid);
          setQty(card, line ? line.quantity : 0, line && line.key);
          bumpQty(box);
        });
      });
    }
    job.catch(function (msg) {
      var num = box.querySelector('.svd-pc__qty-num');
      var was = num.textContent;
      num.textContent = typeof msg === 'string' && /lager|stock|slut|varasto|lager/i.test(msg) ? TXT.sold_out : '!';
      setTimeout(function () { num.textContent = was; }, 1800);
    }).then(function () { box.classList.remove('is-busy'); });
  }
  /* Kort som redan ligger i korgen (egen rad utan stämplar) visar antalet direkt. */
  function syncQtyFromCart() {
    var boxes = document.querySelectorAll('[data-svd-pc-qty]');
    if (!boxes.length) return;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-svd-pc-qty]'), function (box) {
        // Popup-produkter med väljare på PDP:n visar aldrig antalsrutan (köp sker i bladet)
        var b = box.closest('[data-svd-pc]').querySelector('[data-svd-qa]');
        if (b && b.getAttribute('data-lage') === 'popup' &&
            sectionIds[(b.getAttribute('data-mall') || '_standard') + '|picker'] !== 0) return;
        var line = findLine(c.items, box.getAttribute('data-variant-id'));
        setQty(box.closest('[data-svd-pc]'), line ? line.quantity : 0, line && line.key);
      });
    }).catch(function () {});
  }

  /* Direkt i korgen från kortet (antalsläge, och popup-produkter utan väljare):
     tyst tillägg → knappen blir − n +. Saknar kortet antalsrutan (flera varianter)
     blinkar knappen "Tillagd" i stället. */
  function antalAdd(btn) {
    var card = btn.closest('[data-svd-pc]');
    var vid = btn.getAttribute('data-pre-variant') || btn.getAttribute('data-variant-id');
    var box = card && card.querySelector('[data-svd-pc-qty]');
    btn.classList.add('is-loading');
    return cartAdd(vid, !!box).then(function (data) {
      if (!box) { markAdded(btn); return; }
      var line = findLine(data.items || [data], vid);
      setQty(card, line ? line.quantity : 1, line && line.key);
      bumpQty(box);
    }, function (msg) {
      btn.querySelector('.svd-pc__btn-text').textContent = typeof msg === 'string' && msg.length < 40 ? msg : TXT.sold_out;
      setTimeout(function () { btn.querySelector('.svd-pc__btn-text').textContent = TXT.add; }, 2500);
    }).then(function () { btn.classList.remove('is-loading'); });
  }

  /* ---------- Klick ---------- */
  function onClick(btn) {
    if (btn.disabled || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    var variants = parseInt(btn.getAttribute('data-variants'), 10) || 1;
    var lage = btn.getAttribute('data-lage') || 'popup';
    if (lage === 'antal') {
      if (variants > 1) { open(btn); withTimeout(simpleList(btn), 10000).catch(function () { if (isOpenFor(btn)) fallbackLink(btn); }); return; }
      return antalAdd(btn);
    }
    var direct = function () { return antalAdd(btn); };

    if (variants > 1) {
      open(btn);
      withTimeout(load(btn).then(function (res) {
        if (res.picker) return mountPicker(res, btn);
        return simpleList(btn);
      }), 10000).catch(function () { if (isOpenFor(btn)) fallbackLink(btn); });
      return;
    }
    // En variant: väljare på PDP:n? (paketbyggare, bundle picker …) Annars direkt.
    // Mallen känd utan väljare (samma mall = samma block) → direkt utan väntan.
    if (sectionIds[(btn.getAttribute('data-mall') || '_standard') + '|picker'] === 0) return direct();
    btn.classList.add('is-loading');
    withTimeout(load(btn), 8000).then(function (res) {
      btn.classList.remove('is-loading');
      if (!res.picker) return direct();
      open(btn);
      return withTimeout(mountPicker(res, btn), 8000).catch(function () { if (isOpenFor(btn)) fallbackLink(btn); });
    }, function () {
      // Hämtningen misslyckades – produkten kan ha en väljare på produktsidan, så gissa inte
      // (ingen ev. felaktig rad i korgen) och flytta inte kunden: bladet visar länken dit.
      btn.classList.remove('is-loading');
      open(btn);
      fallbackLink(btn);
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-svd-pc-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-svd-pc]');
      var img = card && card.querySelector('.svd-pc__img');
      if (img && sw.getAttribute('data-img')) {
        img.src = sw.getAttribute('data-img');
        img.srcset = sw.getAttribute('data-srcset') || '';
      }
      Array.prototype.forEach.call(card.querySelectorAll('[data-svd-pc-swatch]'), function (b) { b.setAttribute('aria-pressed', 'false'); });
      sw.setAttribute('aria-pressed', 'true');
      var qa = card.querySelector('[data-svd-qa]');
      // Slutsåld nyans vald (Marcus 2026-10): knappen visar "Slutsåld" och går inte att trycka.
      // Kort där hela produkten är slutsåld rörs inte (knappen är redan disabled från Liquid).
      if (qa && !card.classList.contains('svd-pc--slut')) {
        var slut = sw.classList.contains('is-slut');
        var txtEl = qa.querySelector('.svd-pc__btn-text');
        qa.disabled = slut;
        if (txtEl) txtEl.textContent = slut ? TXT.sold_out : TXT.add;
        card.classList.toggle('svd-pc--slut-vald', slut);
        if (!slut) qa.setAttribute('data-pre-variant', sw.getAttribute('data-variant-id'));
      }
      return;
    }
    var q = e.target.closest('[data-svd-qty]');
    if (q) {
      e.preventDefault();
      onQty(q.closest('[data-svd-pc-qty]'), parseInt(q.getAttribute('data-svd-qty'), 10));
      return;
    }
    var btn = e.target.closest('[data-svd-qa]');
    if (btn) { e.preventDefault(); onClick(btn); }
  });

  // Förladda när fingret/musen närmar sig knappen
  function warm(e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-svd-qa]');
    if (btn && !btn.disabled && btn.getAttribute('data-lage') !== 'antal') load(btn).catch(function () {});
  }
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('mouseover', warm, { passive: true });
  document.addEventListener('focusin', warm);

  /* ---------- Förarbete i bakgrunden (så att popupen öppnas direkt) ----------
     När ett popup-kort syns på skärmen hämtas väljaren i förväg, ett kort i taget och
     bara när webbläsaren är ledig – först efter att sidan laddat klart. Väljarens JS
     förladdas (preload, körs inte) och dess CSS läggs in.
     BARA för mallar vars sektions-id redan är känt (cachat från ett tidigare besök/klick).
     Att lära sig ett okänt mall-id kräver att produktsidan läses (~120 KB per mall,
     uppmätt 6/10: 368 KB för tre mallar) – det görs först när kunden rör knappen
     (warm/klick), aldrig i bakgrunden. Spara data-läge / 2G: ingen förhämtning alls. */
  var conn = navigator.connection || {};
  var snal = !!(conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
  var koe = [], koar = false, koat = {}, koAntal = 0, koStopp = false;
  var KO_MAX = 6, KO_PAUS = 900;
  function ledig(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 250); })(fn, { timeout: 2500 }); }
  function preloadJs(src) {
    if (!src || assetLoaded(src) || document.querySelector('link[rel="preload"][href="' + src + '"]')) return;
    var l = document.createElement('link'); l.rel = 'preload'; l.as = 'script'; l.href = src;
    document.head.appendChild(l);
  }
  function korKoe() {
    if (koar || koStopp || !koe.length) return;
    if (koAntal >= KO_MAX) { koe.length = 0; return; }
    koar = true;
    koAntal++;
    var btn = koe.shift();
    ledig(function () {
      var jobb = load(btn, { bakgrund: true }).then(function (res) {
        if (!res || !res.picker) return;
        preloadJs(res.picker.getAttribute('data-svd-picker-js'));
        return Promise.all([loadCss(res.picker.getAttribute('data-svd-picker-css'))].concat((res.palett || []).map(loadCss)));
      });
      withTimeout(Promise.resolve(jobb), 12000).catch(function () {
        // Felsvar (t.ex. butikens skydd 429/503) → ingen mer förhämtning på den här sidvisningen
        koStopp = true; koe.length = 0;
      }).then(function () { setTimeout(function () { koar = false; korKoe(); }, KO_PAUS); });
    });
  }
  function startaForarbete() {
    if (!window.IntersectionObserver || snal) return;
    var io = new IntersectionObserver(function (poster) {
      poster.forEach(function (post) {
        if (!post.isIntersecting) return;
        var b = post.target;
        // Okänt mall-id → vänta (kortet bevakas vidare; lärs mallen in via ett klick köas det nästa gång det syns)
        if (!sectionIds[b.getAttribute('data-mall') || '_standard']) return;
        io.unobserve(b);
        var nyckel = productPath(b.getAttribute('data-url'));
        if (koat[nyckel]) return;
        koat[nyckel] = true;
        koe.push(b); korKoe();
      });
    }, { rootMargin: '150px 0px' });
    var bevaka = function (rot) {
      Array.prototype.forEach.call((rot || document).querySelectorAll('[data-svd-qa][data-lage="popup"]:not([disabled])'), function (b) {
        if (!b._svdIo) { b._svdIo = true; io.observe(b); }
      });
    };
    bevaka();
    window.SvdQuickAddBevaka = bevaka; // Fler produkter laddas in senare (se MutationObserver nedan)
  }
  if (document.readyState === 'complete') ledig(startaForarbete);
  else window.addEventListener('load', function () { ledig(startaForarbete); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncQtyFromCart);
  else syncQtyFromCart();
  // Tillbaka-knappen (bfcache) och korgen ändrad i annan flik → läs om antalen
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncQtyFromCart(); });
  // "Fler produkter" laddas in efteråt (product-recommendations) → synka när korten dyker upp
  if (window.MutationObserver) {
    var syncT;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-svd-pc]') || n.querySelector('[data-svd-pc]'))) {
            clearTimeout(syncT);
            syncT = setTimeout(function () { syncQtyFromCart(); if (window.SvdQuickAddBevaka) window.SvdQuickAddBevaka(); }, 150);
            return;
          }
        }
      }
    });
    var watchRecs = function () {
      Array.prototype.forEach.call(document.querySelectorAll('product-recommendations'), function (el) {
        mo.observe(el, { childList: true, subtree: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchRecs);
    else watchRecs();
  }

  window.SvdQuickAdd = { open: onClick, close: close, sync: syncQtyFromCart };
})();
